<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<p class="center"><a id="page9"></a>For my son, Gavin—a map.</p>
<p class="center">Yeah, it’s <i>really</i> this good.</p>
<p class="center">It’s even better than I could explain.</p>
<p class="center">Enjoy the New, and enjoy Him!</p>
<p class="center">I’m proud of you, boy.</p>
<div class="image" id="image1">
<p class="center"><img alt="image 1" src="images/01.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006dedication.vue?70d52fbe